module.exports = __webpack_public_path__ + "static/img/scx_bg1.0efc5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/scx_bg1.png
// module id = I6dV
// module chunks = 1